import { render, staticRenderFns } from "./trainerFeedBack.vue?vue&type=template&id=4a20c9dc&scoped=true"
import script from "./trainerFeedBack.vue?vue&type=script&lang=js"
export * from "./trainerFeedBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20c9dc",
  null
  
)

export default component.exports